import { createAsyncThunk } from "@reduxjs/toolkit";
import {
	// CREATEPLAYLIST,
	FETCHPLAYLIST,
	FETCH_QUESTION,
	GET_PLAYLIST_DATA,
	ALLSEARCH,
	SUGGESTION_QUESTION,
	PLAYLISTSEARCH,
} from "../../axios/AllBaseUrl";
import { ApiConnector } from "../../axios/apiClient";
/**
 * -------------------------------------------------------
 * Async Thunks
 * -------------------------------------------------------
 * createAsyncThunk is used to handle API calls.
 *
 * For every thunk, Redux automatically dispatches:
 * - pending   → when API call starts
 * - fulfilled → when API call succeeds
 * - rejected  → when API call fails
 *
 * These actions are handled inside `extraReducers`
 * of the corresponding slice.
 */

/**
 * Fetch questions based on provided tags.
 *
 * Used while:
 * - Adding questions to playlist
 * - Filtering questions by tags
 *
 * Handled in extraReducers of Question / Playlist slice.
 */
export const getquestionThunk: any = createAsyncThunk(
	"question/getquestion",
	async (tags: object = []) => {
		const res = await ApiConnector("get", `${FETCH_QUESTION}`, {
			tags: tags,
		});
		if (res.data.ok) {
			return res
		}
		if (res.data.http$.status == 401 && res.data.ok === false) {
			// console.log(res);

			return res
		}
		// return res;
	}
);
/**
 * Search questions using tags with pagination.
 *
 * Used in:
 * - Question search modal
 * - Infinite scroll / paginated question listing
 *
 * NOTE:
 * - `allSearch` flag indicates full search vs tag-based search
 */
export const SearchQuestionThunk: any = createAsyncThunk(
	"search/postSearch",
	async (data: {
		tags: string[], allSearch: number, page: number,
		showItems: number,
	}) => {
		// allSearch ===1 : all Search api || allSearch ===0 : tag seacrh 

		// if (data.allSearch === 1) {			
		let res = await ApiConnector("post", `${ALLSEARCH}`, {
			tags: data?.tags,
			page: data?.page,
			showItems: data?.showItems
		});
		// if (res.data.ok) {
		return res.data.data;
		// }
		// if (res.data.http$.status == 401 && res.data.ok === false) {
		// 	console.log(res.data);
		// 	return res.data
		// }
		// return res.data.data;
		// }
		// if (data.allSearch === 0) {
		// 	let res = await ApiConnector("post", `${SUGGESTION_QUESTION}`, {
		// 		tags: data.tags,
		// 		page: 1,
		// 		showItems: 10
		// 	});
		// 	return res.data.data;
		// }
	}
);
/**
 * Search playlists based on tags.
 *
 * Used in:
 * - Playlist search page
 * - Filter playlists by tag
 */
export const PlaylistSearchThunk: any = createAsyncThunk(
	"playListSearch/playList",
	async (data: any) => {
		let res = await ApiConnector("post", `${PLAYLISTSEARCH}`, {
			tags: data.tags,
			page: data.page,
			showItems: data.showItems
		});
		if (res.data.ok) {
			return res.data;
		}
		if (res.data.http$.status === 401 && res.data.ok === false) {
			console.log(res.data);
			return res.data

		}


	}
);
/**
 * Fetch all playlists with pagination.
 *
 * Used in:
 * - Playlist listing page
 *
 * Lifecycle handled in PlaylistSlice extraReducers:
 * - pending   → show loader
 * - fulfilled → store playlists + pagination
 * - rejected  → show error
 */
export const FetchPlaylistThunk: any = createAsyncThunk(
	"playlistData/PlaylistFetch",
	async (data: any) => {
		return await ApiConnector("post", `${FETCHPLAYLIST}`, {
			tag: data?.tag,
			page: data?.page,
			showItems: data?.showItems
		});
	}
);
/**
 * Fetch details of a single playlist by ID.
 *
 * Used in:
 * - Playlist detail page
 * - Viewing playlist questions
 */
export const ViewPlaylistThunk: any = createAsyncThunk(
	"playlists/ViewPlaylist",
	async (id: any) => {
		let res = await ApiConnector("get", `${GET_PLAYLIST_DATA}/${id}`);
		return res?.data?.data
	}
);
